var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTechnik({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-Technik",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18403",
    "data-name": "Rectangle 18403",
    width: 24.683,
    height: 24.676
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39697",
    "data-name": "Path 39697",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39698",
    "data-name": "Path 39698",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71359",
    "data-name": "Group 71359",
    transform: "translate(14.355 13.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71320",
    "data-name": "Group 71320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35701",
    "data-name": "Path 35701",
    d: "M11.084,17.283V14.8H3.3c-.655,0-.838-.179-.838-.827q0-6.567,0-13.134A1.657,1.657,0,0,1,2.494.472.5.5,0,0,1,2.961.027C3.073.019,3.186,0,3.3,0q9.044,0,18.087,0c.294,0,.613-.019.753.325a1.163,1.163,0,0,1,.08.429q.006,6.645,0,13.29c0,.551-.207.748-.759.748H13.6v2.488h.311q4.691,0,9.383,0a1.3,1.3,0,0,1,1.137.45,1.382,1.382,0,0,1,.244.886q.007,2.358,0,4.717c0,.7-.256,1.1-.788,1.263a2.09,2.09,0,0,1-.59.076q-10.959.005-21.919,0c-.735,0-1.167-.271-1.315-.826A2.147,2.147,0,0,1,0,23.308Q0,20.976,0,18.644c0-.936.437-1.36,1.381-1.361q4.678,0,9.356,0h.343m8.649-14.8H4.952v8.593h14.78ZM6.17,22.214H8.02c.374,0,.747.006,1.12,0,.533-.011.735-.217.743-.75,0-.3,0-.608,0-.912,0-.6-.214-.81-.817-.81H4.976c-.591,0-1.181,0-1.772,0-.5,0-.717.2-.736.7-.012.312,0,.625,0,.938,0,.652.182.833.838.834H6.17m9.867-.008a1.233,1.233,0,1,0,.011-2.465A1.19,1.19,0,0,0,14.8,20.985a1.173,1.173,0,0,0,1.234,1.221m6.173-1.2a1.166,1.166,0,0,0-1.183-1.267,1.185,1.185,0,0,0-1.282,1.2A1.167,1.167,0,0,0,20.936,22.2a1.152,1.152,0,0,0,1.273-1.195",
    transform: "translate(0 0)",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTechnik);
export default __webpack_public_path__ + "static/media/ic-Technik.af74d0c4dd1691a5395d0c093162ff63.svg";
export { ForwardRef as ReactComponent };